import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAm1NlFiDQ27N0kQJPBusragFdW-tvZGx0',
  authDomain: 'tricolite-es.firebaseapp.com',
  projectId: 'tricolite-es',
  storageBucket: 'tricolite-es.firebasestorage.app',
  messagingSenderId: '451205224155',
  appId: '1:451205224155:web:b5eb3987454dfe38885efe',
  measurementId: 'G-WGK3BE452G',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
